module.exports = __webpack_public_path__ + "static/media/thumbnail-anchor.59dba7f6.jpg";